// extracted by mini-css-extract-plugin
export var attachment = "_om-a";
export var emailContainer = "_om-4";
export var emailContentPaddedContainer = "_om-b";
export var emailHeader = "_om-6";
export var emailIframe = "_om-3";
export var emailInfoIcon = "_om-9";
export var emailShortenedSummary = "_om-e";
export var infoDropdown = "_om-0";
export var infoRowBoundedContent = "_om-d";
export var internal = "_om-5";
export var merchant = "_om-8";
export var messageInputContainer = "_om-h";
export var normal = "_om-7";
export var replyCard = "_om-f";
export var subtleButton = "_om-1";
export var subtleButtonIconContainer = "_om-2";
export var toggleViewRepliesButton = "_om-c";
export var wrappingText = "_om-g";